export * from 'koishi-utils'
export * from './adapter'
export * from './app'
export * from './command'
export * from './context'
export * from './database'
export * from './help'
export * from './parser'
export * from './session'

declare const KOISHI_VERSION: string
export const version = KOISHI_VERSION

declare module 'koa' {
  // koa-bodyparser
  interface Request {
    body?: any
    rawBody: string
  }
}
